import script from "./privacyPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&setup=true&lang=js"

import "./privacyPolicy.vue?vue&type=style&index=0&id=251243b6&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251243b6"]])

export default __exports__